import {
  APP_INITIALIZER,
  Inject,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';
import { ConfigService } from '@bo-client/config/config.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TenantService } from '@bo-client/core/api/tenant.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { InitializationService } from '@bo-client/config/initialization.service';

export const CONFIG_FORROOT_GUARD = new InjectionToken('CONFIG_FORROOT_GUARD');

// tslint:disable-next-line:only-arrow-functions
export function provideForRootGuard(config?: ConfigService): any {
  if (config) {
    throw new Error(
      `ConfigModule.forRoot() called twice. Lazy loaded modules should use ConfigModule.forChild() instead.`
    );
  }

  return 'guarded';
}

export function initializerFactory(
  config: ConfigService,
  tenantService: TenantService,
  dataShareService: DataShareService,
  httpClient: HttpClient
) {
  console.log('initializerFAC config...', config, httpClient);
  return () =>
    httpClient
      .get('./assets/config.json')
      .toPromise()
      .then((settings) => {
        config.init(settings);

        tenantService.getTenant().subscribe((tenant) => {
          dataShareService.setTenant(tenant);
        });

        return settings;
      });
}

@NgModule({
  declarations: [],
  exports: [],
  imports: [HttpClientModule]
})
export class ConfigModule {
  static forRoot(): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule,
      providers: [
        ConfigService,
        InitializationService,
        {
          provide: APP_INITIALIZER,
          useFactory: (initializationService: InitializationService) => () => initializationService.init(),
          deps: [InitializationService],
          multi: true
        },
        {
          provide: CONFIG_FORROOT_GUARD,
          useFactory: provideForRootGuard,
          deps: [[ConfigService, new Optional(), new SkipSelf()]]
        }
      ]
    };
  }

  static forChild(): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule
    };
  }

  // tslint:disable-next-line:no-empty
  constructor(@Optional() @Inject(CONFIG_FORROOT_GUARD) guard: any) {}
}
